import { Link, useLocation } from 'react-router-dom';
import './LegalPageNav.css';

export const LEGAL_PAGE_LINKS = [
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/terms', label: 'Terms of Service' },
  { to: '/support', label: 'Support' },
];

export default function LegalPageNav({ className = '' }) {
  const { pathname } = useLocation();

  return (
    <nav className={`legal-page-nav${className ? ` ${className}` : ''}`} aria-label="Legal pages">
      {LEGAL_PAGE_LINKS.map((item) => {
        const active = pathname === item.to;
        return (
          <Link
            key={item.to}
            to={item.to}
            className={`legal-page-nav-link${active ? ' is-active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
